import * as C from './consts'

export function getFrontPage(slug) {
  return {
    types: C.GET_FRONT_PAGE,
    url: `/api/system/front_pages/${slug}`,
  }
}
